import { statusStyle, statusDot } from "@/lib/format";

export default function StatusBadge({ status, className = "" }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${statusStyle[status] || "bg-slate-100 text-slate-700 border-slate-200"} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${statusDot[status] || "bg-slate-400"}`} />
      {status}
    </span>
  );
}
